// Entidade ApiRequest com persistência em localStorage
const API_REQUESTS_KEY = 'api_requests';

// Dados de exemplo para inicialização
const defaultRequests = [
  {
    id: "1",
    name: "GET Exemplo",
    method: "GET",
    url: "https://api.exemplo.com/users",
    headers: [
      { key: "Content-Type", value: "application/json" }
    ],
    params: [
      { key: "page", value: "1" }
    ],
    bodyType: "none",
    rawBody: "",
    formData: [],
    authType: "none",
    authCredentials: {},
    created_date: new Date().toISOString()
  },
  {
    id: "2",
    name: "POST Exemplo",
    method: "POST",
    url: "https://api.exemplo.com/users",
    headers: [
      { key: "Content-Type", value: "application/json" }
    ],
    params: [],
    bodyType: "raw",
    rawBody: JSON.stringify({ name: "Teste", email: "teste@exemplo.com" }),
    formData: [],
    authType: "bearer",
    authCredentials: { token: "abc123" },
    created_date: new Date(Date.now() - 86400000).toISOString() // 1 dia atrás
  }
];

// Função para inicializar o localStorage com dados padrão se estiver vazio
const initializeStorage = () => {
  if (!localStorage.getItem(API_REQUESTS_KEY)) {
    localStorage.setItem(API_REQUESTS_KEY, JSON.stringify(defaultRequests));
  }
};

// Função para obter as requisições do localStorage
const getRequestsFromStorage = () => {
  initializeStorage();
  try {
    return JSON.parse(localStorage.getItem(API_REQUESTS_KEY)) || [];
  } catch (error) {
    console.error('Erro ao obter requisições do localStorage:', error);
    return [];
  }
};

// Função para salvar as requisições no localStorage
const saveRequestsToStorage = (requests) => {
  try {
    localStorage.setItem(API_REQUESTS_KEY, JSON.stringify(requests));
  } catch (error) {
    console.error('Erro ao salvar requisições no localStorage:', error);
  }
};

export class ApiRequest {
  static async list(sortBy = "-created_date", limit = 100) {
    // Obter requisições do localStorage
    const requests = getRequestsFromStorage();
    
    // Ordenação
    let sortedRequests = [...requests];
    if (sortBy.startsWith("-")) {
      const field = sortBy.substring(1);
      sortedRequests.sort((a, b) => (a[field] > b[field] ? -1 : 1));
    } else {
      sortedRequests.sort((a, b) => (a[sortBy] > b[sortBy] ? 1 : -1));
    }
    
    return sortedRequests.slice(0, limit);
  }

  static async create(requestData) {
    // Obter requisições atuais
    const requests = getRequestsFromStorage();
    
    // Criar nova requisição
    const newRequest = {
      id: String(Date.now()), // Usar timestamp como ID único
      ...requestData,
      created_date: new Date().toISOString()
    };
    
    // Adicionar à lista e salvar
    requests.push(newRequest);
    saveRequestsToStorage(requests);
    
    return newRequest;
  }

  static async update(id, data) {
    // Obter requisições atuais
    const requests = getRequestsFromStorage();
    
    // Encontrar e atualizar a requisição
    const index = requests.findIndex(request => request.id === id);
    if (index !== -1) {
      requests[index] = { ...requests[index], ...data };
      saveRequestsToStorage(requests);
      return requests[index];
    }
    throw new Error("Requisição não encontrada");
  }

  static async delete(id) {
    // Obter requisições atuais
    const requests = getRequestsFromStorage();
    
    // Verificar se a requisição existe
    const index = requests.findIndex(request => request.id === id);
    if (index !== -1) {
      // Filtrar a requisição a ser excluída
      const updatedRequests = requests.filter(request => request.id !== id);
      saveRequestsToStorage(updatedRequests);
      return true;
    }
    throw new Error("Requisição não encontrada");
  }
}
